<script>
import { cloneDeep } from 'lodash-es';
import NonDynamicTransportTripRow from './NonDynamicTransportTripRow';

export default {
  name: 'NonDynamicTransportTrip',
  components: {
    NonDynamicTransportTripRow,
  },
  props: {
    transits: {
      type: Array,
      required: true,
    },
    trips: {
      type: Array,
      default: () => [],
    },
    defaultTrip: {
      type: Object,
      required: true,
    },
    defaultTripSeating: {
      type: Object,
      required: true,
    },
    defaultTripConsumables: {
      type: Object,
      required: true,
    },
    defaultTripUpgrade: {
      type: Object,
      required: true,
    },
    carriers: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      required: true,
    },
    tripUpgradeTypes: {
      type: Array,
      required: true,
    },
    tripConsumableTypes: {
      type: Array,
      required: true,
    },
    tripSeatingSectionTypes: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      localTrips: [],
    };
  },
  created() {
    if (!this.trips.length) {
      this.localTrips.push(cloneDeep(this.defaultTrip));
    } else {
      this.localTrips = [...this.trips];
    }
  },
  methods: {
    addTripRow(index) {
      const trips = [...this.localTrips];
      trips.splice(index + 1, 0, cloneDeep(this.defaultTrip));
      this.localTrips = [...trips];
    },
    deleteTripRow(index) {
      const trips = [...this.localTrips];
      trips.splice(index, 1);
      this.localTrips = [...trips];
    },
    updateTrip(event) {
      const trips = [...this.localTrips];
      trips[event.index][event.attribute] = event.value;
      this.localTrips = [...trips];
    },
  },
  watch: {
    localTrips: {
      handler(value) {
        this.$emit('update', value);
        this.$forceUpdate();
      },
      deep: true,
    },
    trips: {
      handler(value) {
        this.localTrips = value;
      },
      deep: true,
    },
  },
};
</script>

<template>
  <v-layout column wrap>
    <h5 class="mb-2">{{ title }}</h5>
    <v-divider class="mb-2"/>
    <non-dynamic-transport-trip-row
      v-for="(trip, index) in localTrips"
      :key="`non-dynamic-transport-trip-row-${index}`"
      :index="index"
      :trip="trip"
      :carriers="carriers"
      :transits="transits"
      :trip-upgrade-types="tripUpgradeTypes"
      :trip-consumable-types="tripConsumableTypes"
      :trip-seating-section-types="tripSeatingSectionTypes"
      :default-trip-seating="defaultTripSeating"
      :default-trip-consumables="defaultTripConsumables"
      :default-trip-upgrade="defaultTripUpgrade"
      @add="addTripRow"
      @remove="deleteTripRow"
      @update="updateTrip"
    />
  </v-layout>
</template>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportTrip.vue